const commentItems = [
  {
    name: '追剧达人小王',
    text: '用了90影视之后就把其他视频APP都卸载了！片库太全了，想看的电影电视剧基本都有，而且真的没有广告，体验太好了。',
    rating: 5,
    time: '3天前',
  },
  {
    name: '影迷老张',
    text: '画质很清晰，加载速度也快，不像有些网站卡半天。国产剧更新很及时，综艺也有，追剧追综艺一个站就够。',
    rating: 5,
    time: '1周前',
  },
  {
    name: '动漫爱好者小明',
    text: '动漫资源挺全的，国漫日漫都有，而且都是高清版。最重要的是免费！不用充会员就能看所有内容，真的很良心。',
    rating: 5,
    time: '2周前',
  },
  {
    name: '全职妈妈李姐',
    text: '每天晚上哄完孩子睡觉就打开90影视追两集剧，已经成为习惯了。资源更新快，操作也简单，推荐给身边好多朋友了。',
    rating: 5,
    time: '3周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-white">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-black text-gray-900">追剧好评</h2>
            <p className="text-sm text-gray-500 mt-2">来自真实用户的观影体验分享</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {commentItems.map((item, idx) => (
              <div key={idx} className="bg-gray-50 rounded-xl p-5 border border-gray-100">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-warm-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                  ))}
                </div>
                <p className="text-sm text-gray-600 leading-relaxed mb-4">{item.text}</p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-gray-800 whitespace-nowrap">{item.name}</span>
                  <span className="text-xs text-gray-400 whitespace-nowrap">{item.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}